<template lang="html">
  <div
    class="modal"
    :class="{'is-open': isOpen}"
    @click="closeIfPossible">
    <div class="modal-container" @click.stop="preventClick">
      <div class="modal-header">
        <h2 v-if="title" class="modal-title">{{title}}</h2>
        <slot name="header">
          <button
            type="button"
            class="button is-square is-rounded is-xsmall is-gray-100 modal-close"
            v-on:click="close">
            <span class="css-icon is-close"></span>
          </button>
        </slot>
      </div>
      <div class="modal-content">
        <slot name="content"></slot>
      </div>
      <div class="modal-footer">
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>

<script lang="js">
import { eventHubMixin } from '@/mixins/event';

export default {
  name: 'VqModal',
  mixins: [eventHubMixin],
  components: {
  },
  filters: {
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    title: {
      type: String,
    },
    canClose: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {
    this.eventHub.$on(`modal:${this.name}:close`, () => this.close());
    this.eventHub.$on(`modal:${this.name}:open`, () => this.open());
  },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    open() {
      this.isOpen = true;
    },

    closeIfPossible() {
      if (this.canClose) {
        this.close();
      }
    },

    close() {
      this.isOpen = false;
    },

    preventClick() {
      this.eventHub.$emit('document:click');
    },
  },
};
</script>
